import React from 'react';
import { formatBlogDate, formatSidebarDate } from '../../common/blogStore';

export function BlogListItem({ blog, isLast }) {
  return (
    <div className={`item ${isLast ? '' : 'mb-80'}`}>
      <div className="img">
        <img src={blog.coverImg || '/assets/imgs/blog/blog1.jpg'} alt={blog.title} />
      </div>
      <div className="content">
        <div className="d-flex align-items-center mb-15">
          <div className="post-date">{formatBlogDate(blog.date)}</div>
          <div className="commt opacity-7 fz-13">
            <span className="ti-comment-alt mr-10"></span>
            {blog.comments || 0} Yorum
          </div>
        </div>
        <h3 className="mb-15">
          <a href={`/blog-details/${blog.id}`}>
            {blog.title}{' '}
            {blog.titleHighlight && (
              <span className="fw-200">{blog.titleHighlight}</span>
            )}
          </a>
        </h3>
        <p>{blog.excerpt}</p>
        <a
          href={`/blog-details/${blog.id}`}
          className="d-flex align-items-center main-color mt-40"
        >
          <span className="text mr-15">Devamını Oku</span>
          <span className="ti-arrow-top-right"></span>
        </a>
      </div>
    </div>
  );
}

export function BlogSidebar({ blogs, currentId }) {
  const recent = blogs.filter((b) => b.id !== currentId).slice(0, 3);
  const categories = {};
  blogs.forEach((b) => {
    categories[b.category] = (categories[b.category] || 0) + 1;
  });

  return (
    <div className="sidebar">
      <div className="widget">
        <h6 className="title-widget">Ara</h6>
        <div className="search-box">
          <input type="text" name="search-post" placeholder="Blogda ara..." />
          <span className="icon pe-7s-search"></span>
        </div>
      </div>
      <div className="widget catogry">
        <h6 className="title-widget">Kategoriler</h6>
        <ul className="rest">
          {Object.entries(categories).map(([name, count]) => (
            <li key={name}>
              <span>
                <a href="/blog-classic">{name}</a>
              </span>
              <span className="ml-auto">{count}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className="widget last-post-thum">
        <h6 className="title-widget">Son Yazılar</h6>
        {recent.map((blog) => (
          <div key={blog.id} className="item d-flex align-items-center">
            <div>
              <div className="img">
                <a href={`/blog-details/${blog.id}`}>
                  <img src={blog.coverImg || '/assets/imgs/blog/c1.jpg'} alt="" />
                  <span className="date">
                    <span>
                      {formatSidebarDate(blog.date).split(' / ')[0]} / <br />
                      {formatSidebarDate(blog.date).split(' / ')[1]}
                    </span>
                  </span>
                </a>
              </div>
            </div>
            <div className="cont">
              <span className="tag">
                <a href="/blog-classic">{blog.category}</a>
              </span>
              <h6>
                <a href={`/blog-details/${blog.id}`}>
                  {blog.title} {blog.titleHighlight}
                </a>
              </h6>
            </div>
          </div>
        ))}
      </div>
      <div className="widget tags">
        <h6 className="title-widget">Etiketler</h6>
        <div>
          {[...new Set(blogs.flatMap((b) => b.tags || []))].slice(0, 6).map((tag) => (
            <a key={tag} href="/blog-classic">{tag}</a>
          ))}
        </div>
      </div>
    </div>
  );
}
